export default "__VITE_ASSET__CEETP6$N__"